'use client';

import { useEffect } from 'react';
import { LoginLink } from '@kinde-oss/kinde-auth-nextjs/components';
import Image from 'next/image';
import { useRouter, useSearchParams } from 'next/navigation';

import LoadingFullScreen from '@/app/components/ui/loading-full-screen/LoadingFullScreen';
import { useAuth } from '@/app/providers/auth-provider';
import { AuthStatus } from '@/types';

const DEFAULT_LANDING = '/dashboard';

const isSafeRedirectTarget = (next: string | null): next is string => {
	return (
		typeof next === 'string' &&
		next.startsWith('/') &&
		!next.startsWith('//') &&
		!next.startsWith('/\\')
	);
};

const LandingPage = () => {
	const router = useRouter();
	const params = useSearchParams();
	const { state } = useAuth();
	const nextParam = params.get('next');
	const next = isSafeRedirectTarget(nextParam) ? nextParam : DEFAULT_LANDING;

	useEffect(() => {
		if (state.status === AuthStatus.Authenticated) {
			router.replace(next);
		}
	}, [state.status, router, next]);

	if (state.status === AuthStatus.Loading || state.status === AuthStatus.Authenticated) {
		return <LoadingFullScreen />;
	}

	return (
		<div className="flex w-full max-w-md flex-col items-center gap-8 rounded-2xl bg-white p-10 shadow-sm">
			<div className="flex items-center gap-3">
				<span className="flex h-12 w-12 items-center justify-center rounded-full bg-dd-gray-light p-2 shadow-sm">
					<Image
						src="https://assets.doughdog.co/svgs/dog-head.svg"
						alt="DoughDog"
						width={32}
						height={32}
					/>
				</span>
				<span className="text-2xl font-semibold tracking-tight text-dd-gray-darkest">
					Dough Dog
				</span>
			</div>

			<p className="text-center text-sm text-gray-700">
				Open this app from your Shopify admin under <strong>Apps → DoughDog</strong>.
			</p>

			<LoginLink
				postLoginRedirectURL={next}
				className="text-xs font-medium text-gray-500 underline-offset-2 transition-colors hover:text-dd-gray-darkest hover:underline">
				Alternative sign in
			</LoginLink>
		</div>
	);
};

export default LandingPage;
